import * as React from "react"
import { Layout } from "../components/layout"
import { graphql } from 'gatsby';
import {
  iframe
} from "./book-call.module.css"
import { title, sectionMandatPad } from "./index.module.css"
import { Seo } from "../components/seo"
import IframeWithLoadingSpinner from '../components/IframeWithLoadingSpinner';
import { useSeekaConverge } from '@seeka-labs/converge-react';

export default function BookCall({ data, pageContext }) {
  const converge = useSeekaConverge();

  // Execute the tracking code only in the client-side environment
  if (converge) {
    converge.track.viewContentItem({
      contentName: 'Book Call'
    });
  }
  const page = data.storefront.page;
  const url = "https://calendly.com/art_works_advisory/15min/?embed_domain=www.artworks.com.sg&amp;embed_type=Inline&amp;text_color=101010&amp;primary_color=25695A";
  return (
    <Layout>
      <div className={sectionMandatPad}>
        <h2 className={title}>{page.title}</h2>
        {/* Use IframeWithLoadingSpinner component instead of a plain iframe */}
        <IframeWithLoadingSpinner
          src={url}
          width={800}
          height={800}
          iframeName="book-a-call"
        />
      </div>
    </Layout>
  );
};

export const Head = ({ data: { storefront } }) => <Seo title={storefront.page.seo.title}
  description={storefront.page.seo.description} />
export const query = graphql`
  query BookCall {
  storefront {
    page(handle: "book-call") {
      seo {
        description
        title
      }
      title
      handle
      body
    }
  }
}
`